<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRouteResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../route/TableExpand.vue";
var tableRouteResourceVue = {};
export default {
  name: "TableRouteResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.routingTable.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.routingTable.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.routingTable.routingTableName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.routingTable.routingTableID"),
          key: "routeTableId"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        },
        {
          title: this.$t("RAM.AWS.routingTable.isMainRoutingTable"),
          key: "main"
        }
      ],
      tableRouteResourceListData: [],
      accountNameSearchIDVal: ""
    };
  },
  beforeCreate: function() {
    tableRouteResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableRouteResourceVue.accountNameSearchIDVal = accountNameSearchIDVal;
    });
    eventBus.$on("companyId", function(val) {
      tableRouteResourceVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableRouteResourceVue.getRouteResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getRouteResourceListData: function() {
      this.$api.resourceManagement
        .selectAWSRouteTableByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: this.companyId,
          accountName: this.accountNameSearchIDVal
        })
        .then(res => {
          this.tableRouteResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableRouteResourceVue.getRouteResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRouteResourceVue.getRouteResourceListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {
      eventBus.$off("accountNameSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/route/TableRouteResource.vue